export const SessionActions = {
    LOGIN:      'auth_01',
    LOGOUT:     'auth_02',
};
